import React from "react";
import { healthTargetPath } from "../../Settings/constants";
import { PlanLink } from "../styles";
import { PlanBanner } from "./styles";

export const PlanNoTargetsBanner: React.FC = () => (
  <PlanBanner data-testid="plan-no-targets">
    <span>
      No targets yet: these numbers aren&apos;t graded until you set one.
    </span>
    <PlanLink href={healthTargetPath("savingsRate")}>Set targets</PlanLink>
  </PlanBanner>
);
